import { render, staticRenderFns } from "./InvalidLink.vue?vue&type=template&id=39a89c68&"
import script from "./InvalidLink.vue?vue&type=script&lang=js&"
export * from "./InvalidLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports